import { adminApi } from './api';
import type {
  PromoCode,
  PromoCodeDetail,
  CreatePromoCodeInput,
  CreatePromoCodeResponse,
} from '../types/promoCode.types';

export const promoCodesService = {
  async getPromoCodes(): Promise<PromoCode[]> {
    const { data } = await adminApi.get<{ codes: PromoCode[] }>('/admin/promo-codes');
    return data.codes;
  },

  async getPromoCode(id: string): Promise<PromoCodeDetail> {
    const { data } = await adminApi.get<PromoCodeDetail>(`/admin/promo-codes/${id}`);
    return data;
  },

  async createPromoCode(input: CreatePromoCodeInput): Promise<CreatePromoCodeResponse> {
    const { data } = await adminApi.post<CreatePromoCodeResponse>('/admin/promo-codes', input);
    return data;
  },

  async deactivatePromoCode(id: string): Promise<void> {
    await adminApi.delete(`/admin/promo-codes/${id}`);
  },

  async getInviteLink(code: string): Promise<string> {
    const { data } = await adminApi.get<{ inviteLink: string }>(`/admin/promo-codes/${code}/invite-link`);
    return data.inviteLink;
  },
};

export default promoCodesService;
